/**
 * Signatures are dark ink on a transparent background (drawn, uploaded and
 * re-encoded server side), so they are always shown on white "paper" rather
 * than the theme background. Otherwise the ink vanishes in dark mode, and a
 * signature would look different depending on the viewer's theme.
 */

/** Ink colour for drawn signatures. Matches the text colour of the surface. */
export const SIGNATURE_INK_COLOR = '#0f172a'

/** Background and text colour for anywhere a signature is captured or previewed. */
export const SIGNATURE_SURFACE_CLASS = 'bg-white text-slate-900'

/** Placeholder text on a signature surface (the theme's muted colour is too faint on white in dark mode). */
export const SIGNATURE_PLACEHOLDER_CLASS = 'text-slate-400'

/** Read-only rendering of an applied signature (image or typed), so every method looks the same. */
export const SIGNATURE_DISPLAY_CLASS = `inline-block rounded-sm px-2 py-1 ${SIGNATURE_SURFACE_CLASS}`
